<div class="row">
  <!-- Columns 1 & 2: Comparison Table (Enin Data vs Supplier Data) -->
  <div class="col-12" [class.col-lg-9]="!printView()" [class.mb-3]="!printView()" [class.mb-lg-0]="!printView()">
    @if (isLegacy()) {
      <!-- Legacy: Enin data row, then PDF row below -->
      <div class="mb-3">
        <h5>
          {{ 'screening.case.comparison.entity_under_screening' | translate }}
        </h5>
        @if (eninData(); as data) {
          <div class="d-flex flex-wrap gap-4">
            <div>
              <label class="text-muted small">{{ 'screening.case.comparison.name' | translate }}</label>
              <p class="mb-0">{{ data.name || '-' }}</p>
            </div>
            @if (isCompany()) {
              <div>
                <label class="text-muted small">{{ 'screening.case.comparison.registration_date' | translate }}</label>
                <p class="mb-0">{{ data.registrationDate ? (data.registrationDate | date) : '-' }}</p>
              </div>
            } @else {
              <div>
                <label class="text-muted small">{{ 'screening.case.comparison.birth_date' | translate }}</label>
                <p class="mb-0">{{ data.birthDate ? (data.birthDate | date) : '-' }}</p>
              </div>
            }
            <div>
              <label class="text-muted small">{{ 'screening.case.comparison.country' | translate }}</label>
              <p class="mb-0">{{ data.countryName || '-' }}</p>
            </div>
            @if (isCompany() && companyLocations().length > 0) {
              @for (location of companyLocations(); track location.uuid) {
                <div>
                  <label class="text-muted small">{{ 'screening.case.comparison.address' | translate }}</label>
                  <p class="mb-0">
                    @if (location.street_address) {
                      {{ location.street_address }},
                    }
                    {{ location.postal_code }} {{ location.postal_place }}
                    @if (location.country_name) {
                      , {{ location.country_name }}
                    }
                  </p>
                </div>
              }
            } @else {
              <div>
                <label class="text-muted small">{{ 'screening.case.comparison.address' | translate }}</label>
                <p class="mb-0">{{ data.address || '-' }}</p>
              </div>
            }
          </div>
        }
      </div>
      <div>
        <h5>{{ 'screening.case.comparison.possible_match' | translate }}</h5>
        @if (screeningConfigUuid(); as configUuid) {
          <nk-screening-case-report-pdf
            [printView]="printView()"
            [screeningConfigUuid]="configUuid"
            [screeningCaseComposite]="screeningCaseComposite()"></nk-screening-case-report-pdf>
        }
      </div>
    } @else {
      <!-- Table comparison layout -->
      @if (supplierData().length > 0) {
        @for (risk of supplierData(); track risk.match_name + risk.match_score; let last = $last) {
          <table class="table table-dense table-striped mb-3" [class.mb-4]="!last">
            <thead>
              <tr>
                <th style="min-width: fit-content"></th>
                <th style="min-width: 50%">
                  {{ 'screening.case.comparison.entity_under_screening' | translate }}
                </th>
                <th style="min-width: 50%">{{ 'screening.case.comparison.possible_match' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="text-muted">{{ 'screening.case.comparison.name' | translate }}</td>
                <td>{{ eninData()?.name || '-' }}</td>
                <td>
                  @if (risk.match_name) {
                    <span
                      [innerHTML]="
                        risk.match_name | highlightText: highlightTexts() : 'highlightText highlightText-yellow'
                      "></span>
                  } @else {
                    -
                  }
                </td>
              </tr>
              @if (isCompany()) {
                <tr>
                  <td class="text-muted">{{ 'screening.case.comparison.registration_date' | translate }}</td>
                  <td>{{ eninData()?.registrationDate ? (eninData()!.registrationDate | date) : '-' }}</td>
                  <td>-</td>
                </tr>
              } @else {
                <tr>
                  <td class="text-muted">{{ 'screening.case.comparison.birth_date' | translate }}</td>
                  <td>{{ eninData()?.birthDate ? (eninData()!.birthDate | date) : '-' }}</td>
                  <td>
                    @if (risk.datesOfBirth.length > 0) {
                      @for (dob of risk.datesOfBirth; track dob.value; let lastDob = $last) {
                        {{ dob.value | date }}
                        @if (!lastDob) {
                          ,
                        }
                      }
                    } @else {
                      -
                    }
                  </td>
                </tr>
              }
              <tr>
                <td class="text-muted">{{ 'screening.case.comparison.country' | translate }}</td>
                <td>{{ eninData()?.countryName || '-' }}</td>
                <td>-</td>
              </tr>
              @if (isCompany() && companyLocations().length > 0) {
                @for (location of companyLocations(); track location.uuid) {
                  <tr>
                    <td class="text-muted">{{ 'screening.case.comparison.address' | translate }}</td>
                    <td>
                      @if (location.street_address) {
                        {{ location.street_address }}<br />
                      }
                      {{ location.postal_code }} {{ location.postal_place }}
                      @if (location.country_name) {
                        <br />{{ location.country_name }}
                      }
                    </td>
                    <td>-</td>
                  </tr>
                }
              } @else {
                <tr>
                  <td class="text-muted">{{ 'screening.case.comparison.address' | translate }}</td>
                  <td>{{ eninData()?.address || '-' }}</td>
                  <td>-</td>
                </tr>
              }
              <tr>
                <td class="text-muted">{{ 'screening.case.comparison.info' | translate }}</td>
                <td>
                  @if (!isCompany()) {
                    @if (personInputData(); as inputData) {
                      @if (inputData.type === 'person') {
                        <nk-person-ownership
                          [inputData]="inputData"
                          [screeningConfigUuid]="screeningConfigUuid()"
                          [screeningEntityUuid]="screeningCaseComposite().screening_entity.uuid"></nk-person-ownership>
                        <nk-person-company-roles
                          [inputData]="inputData"
                          [screeningConfigUuid]="screeningConfigUuid()"
                          [screeningEntityUuid]="
                            screeningCaseComposite().screening_entity.uuid
                          "></nk-person-company-roles>
                      }
                    }
                  }
                </td>
                <td>
                  <nk-screening-case-supplier-risk-context
                    [risk]="risk"
                    [showHeader]="false"
                    [highlightTexts]="highlightTexts()"></nk-screening-case-supplier-risk-context>
                </td>
              </tr>
            </tbody>
          </table>
        }
      } @else {
        <p class="text-muted">{{ 'screening.case.comparison.no_supplier_data' | translate }}</p>
      }
    }
  </div>

  <!-- Column 3: Review Form -->
  @if (!printView()) {
    <div class="col-12 col-lg-3 sticky-element">
      <h5>{{ 'screening.case.comparison.review' | translate }}</h5>
      @if (screeningConfigUuid(); as configUuid) {
        <nk-card>
          <nk-card-content>
            <nk-screening-case-review-editor
              [screeningCaseComposite]="screeningCaseComposite()"
              [screeningConfigUuid]="configUuid"
              [screeningCaseReviewStatusList]="screeningCaseReviewStatusList()"
              [severalMatches]="supplierData().length > 1"
              (reviewSaved)="reviewSaved.emit()"
              (reviewCreated)="reviewCreated.emit()"></nk-screening-case-review-editor>
          </nk-card-content>
        </nk-card>
      }
    </div>
  }
</div>
